import React, { useEffect, useState } from "react";
import { Getdata } from "../../helpers/api.service";
import { useNavigate } from "react-router-dom";
import pdfIcon from "../../assets/icons/pdf.svg"

const FeeStructure = () => {
  const [data, setData] = useState([]);
  let [loading, setLoading] = useState(false);

  const fetchData = () => {
    setLoading(true);
    Getdata(
      process.env.REACT_APP_URL +
      `/front/admission-details/fee-structure/${process.env.REACT_APP_SUBDOMAIN}`
    )
      .then((res) => {
        console.log("News API response:", res);
        if (res?.data) {
          setData(res.data);
        }
        // setImages(res.data.map((item) => item.image));
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching news:", err);
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div className="mx-4 sm:mx-6 md:mx-10 lg:mx-32 xl:mx-24 2xl:mx-30 3xl:mx-20 4xl:mx-52">
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-4 gap-6 sm:gap-8">
        {data.length > 0 &&
          data.map((item, index) => (
            <div
              key={index}
              className="border border-[#f0eeee] bg-[#F9F5FF] rounded-lg p-3 flex flex-col items-center sm:items-start"
            >
              <a href={item.file} target="_blank" rel="noopener noreferrer">
                <img src={pdfIcon} alt="pdf" className="w-16" />
              </a>
              <div className="mt-3 font-bold text-center sm:text-left w-full break-words text-sm sm:text-base md:text-lg">
                {item.title}
              </div>
            </div>
          ))}
      </div>

      {data.length === 0 && !loading && (
        <div className="h-[50vh] flex items-center justify-center w-full">
          <h1 className="text-center text-gray-400 text-sm sm:text-base md:text-lg">
            No Data Found
          </h1>
        </div>
      )}
    </div>

  );
};

export default FeeStructure;
